import React from 'react';
import { connect } from 'react-redux';
import { hospitalSingleCreate } from '../../lib/redux/actions/hospitals';
import { addToast } from '../../lib/redux/actions/toast';
import HospitalCreate from './HospitalCreate';
import * as ROUTES from '../../lib/routing/frontend';

const mapStateToProps = (state) => ({
  ...state.hospitals,
});

const mapDispatchToProps = {
  hospitalSingleCreate,
  addToast,
};

class HospitalCreateContainer extends React.Component {
  onCreate = async (hospitalData) => {
    try {
      const response = await this.props.hospitalSingleCreate(hospitalData);
      this.props.addToast('Hospital created successfully', true, false);
      // Redirect to the newly created hospital's edit page
      this.props.history.push(ROUTES.HOSPITALS.SINGLE.replace(':id', response.id));
      return response;
    } catch (error) {
      this.props.addToast('Failed to create hospital', false, true);
      throw error;
    }
  };

  render() {
    return <HospitalCreate onCreate={this.onCreate} {...this.props} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HospitalCreateContainer);
